export default "__VITE_ASSET__11558bcc__"